<template>
    <div v-if="featuresUrls && featuresUrls.length" class="features-model" id="part4" ref="part4">
        <div class="part_section" id="section1"></div>
        <div class="swiper">
          <template v-if="featuresUrls.length > 1">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide v-for="(item,index) in featuresUrls" :key="index"><a :href="item.linkUrl" target="_blank"><img :src="item.imageUrl"/></a></swiper-slide>
              <div class="swiper-button-prev" slot="button-prev">
                <img src="https://resource.rcclchina.com.cn/cruiseDetail/swiper/swiper-btn-left.png"/>
              </div>
              <div class="swiper-button-next" slot="button-next">
                <img src="https://resource.rcclchina.com.cn/cruiseDetail/swiper/swiper-btn-right.png"/>
              </div>
            </swiper>
            <div class="swiper-pagination"></div>
          </template>
          <template v-else>
            <img :src="featuresUrls[0].url"/>
          </template>
        </div>
    </div>
</template>

<script>

// import api from '@/api'
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  name: "CruiseDetailFeatures",
  components: {
    Swiper,
    SwiperSlide
  },
    props: {
      featuresUrls: {
          type: Array
      }
    },
    data () {
        return {
          swiperOption: {
            loop: true,
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets'
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          }
        }
    },
    methods: {
    },
    computed: {
    },
    watch: {
    }
}
</script>

<style lang="less" scoped>
.features-model {
  margin: 0 auto 10px;
  position: relative;
  height: 120px;
  width: 100%;
  & .swiper {
    position: relative;
    & .swiper-slide > a {
      display: block;
      width: 100%;
      height: 120px;
      & > img {
        width: 100%;
        height: 100%;
      }
    }
    & .swiper-button-next,
    & .swiper-button-prev {
      width: 32px;
      height: 42px;
      top: 52%;
      background-image: none;
      & > img {
        height: 100%;
        width: 100%;
      }
    }
    & .swiper-button-prev {
      left: 4px;
    }
    & .swiper-button-next {
      right: 4px;
    }
    & .swiper-button-next:after,
    & .swiper-button-prev:after {
      content: none;
    }
    & .swiper-pagination {
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.part_section {
  position: absolute;
  top: -10px;
}
/deep/.swiper-pagination-bullet {
  margin: 0 2px;
  background: rgba(238,238,238,.8);
}
/deep/.swiper-pagination-bullet-active {
  background: #EEEEEE;
}
</style>
